import React from 'react'
import PropTypes from 'prop-types';
import Image from '~components/Image'

const ImageBlock = ({ image, aspectRatio, className }) => {
  return (
    <div className={className}>
        <Image asset={image} aspectRatio={aspectRatio} />
    </div>
  )
}

ImageBlock.propTypes = {
  image: PropTypes.object,
}

ImageBlock.defaultProps = {
}

export default ImageBlock
